import getFilterWithCol from '../../helpers/getFilterWithCol';
import { getProductsUrl } from '../../helpers/getStoreUrl';
import { getI18nFields, fieldI18nLanguage } from '../../helpers/i18n';
import createSlug from '../../helpers/createSlug';

import { createChangeLogSection } from '../../components/FieldChangeLog';

export const fieldName = ['FieldText', {
  name: 'name',
  rules: [['validation.isRequired']],
  i18nTranslatable: true,
  prepareValueForForm: (value, props) => {
    if (props.activity === 'create') {
      let i18nLanguageValue = null;
      const form = (
          props.forms
        ? props.forms[props.forms.length - 1]
        : props.form
      );
      if (form && form.getFieldValue) {
        i18nLanguageValue = form.getFieldValue('i18nLanguage') || 'en';
      } else {
        i18nLanguageValue = 'en';
      }
      if (i18nLanguageValue === 'en') {
        props.form.setFieldsValue({ slug: createSlug(value?.target?.value) });
      }
    }
    return value;
  },
}];

export const fieldStoreDivider = ['Divider', {
  name: 'storeDivider',
}];

export const fieldStore = ['FieldConnectionSelect', {
  name: 'store',
  placeholder: 'Select the category store',
  url: '/stores/list',
  // getChoiceLabel: choice => choice.data.name,
  searchPaths: ['name'],
  rules: [['validation.isRequired']],
  disabled: [props => props.activity !== 'create'],
  virtual: [props => props.activity !== 'create'],
}];

export const fieldSlug = ['FieldSlug', {
  name: 'slug',
  rules: [['validation.isRequired']],
  copyLinkValue: value => `?category=${value}`,
  copyLinkSegments: [
    (props) => {
      if (props.data && props.data.storeData) {
        return getProductsUrl(props.data.storeData);
      }
      return null;
    },
  ],
  addonBefore: '?category=',
}];

export const fieldSubcategories = ['FieldSortableList', {
  name: 'subcategories',
  label: 'Subcategories',
  supportDuplicate: true,
  addButtonLabel: 'Add Subcategory',
  shouldRenderPlaceholder: true,
  condensed: true,
  getItemFields: getI18nFields,
  head: 'horizontal',
  fields: [
    getFilterWithCol(['FieldText', {
      label: null,
      name: 'name',
      prefix: 'Name:',
      // col: { xs: { span: 24 }, lg: { span: 8 } },
      i18nTranslatable: true,
      prepareValueForForm: (value, props) => {
        let i18nLanguageValue = null;
        const form = (
          props.forms
            ? props.forms[props.forms.length - 1]
            : props.form
        );
        if (form && form.getFieldValue) {
          i18nLanguageValue = form.getFieldValue('i18nLanguage') || 'en';
        } else {
          i18nLanguageValue = 'en';
        }
        if (i18nLanguageValue === 'en') {
          props.form.setFieldsValue({
            slug: createSlug(value?.target?.value),
          });
        }
        return value;
      },
    }], 12),
    getFilterWithCol(['FieldSlug', {
      label: null,
      name: 'slug',
      rules: [['validation.isRequired']],
      copyLinkValue: value => `?category=${value}`,
      // copyLinkSegments: [
      //   (props) => {
      //     if (props.data && props.data.storeData) {
      //       return getProductsUrl(props.data.storeData);
      //     }
      //     return null;
      //   },
      // ],
      addonBefore: '?sub=',
    }], 12),
  ],
}];

export const ADMIN = [
  fieldI18nLanguage,
  fieldStore,
  fieldName,
  fieldSlug,
  fieldSubcategories,
  ...createChangeLogSection({
    changeLogConfig: {
      getWhereConditions: props => ({
        store: props.data?.store,
        'target.type': 'Category',
        'target.subject': props.data._id,
      }),
      skipColumns: {
        store: true,
        realm: true,
        target: true,
      },
    },
  }),
];

export const SELLER = [
  fieldI18nLanguage,
  fieldName,
  fieldSlug,
  fieldSubcategories,
];
